import { DeepPartial } from '../../../types';
import { RoadSection, RoadSectionId } from '../../domain/Reference';
import { setModalToDisplay, unsetReferenceModalToDisplay } from '../../legacy/actions/modals';
import { ReferenceModalTypes } from '../../legacy/reducers/modals';
import { createCommand } from '../../utils';
import { moduleName, updatedRoadSections } from '../state';

interface EditRoadSectionsParams {
    roadSectionIds: RoadSectionId[];
    roadSectionData: DeepPartial<RoadSection>;
}

const editRoadSections = createCommand(
    `${moduleName}/EDIT_ROAD_SECTION`,
    async ({ roadSectionData, roadSectionIds }: EditRoadSectionsParams, { dispatch, extra }) => {
        try {
            const roadSections = await extra.externalReference.editRoadSections(roadSectionIds, roadSectionData);
            dispatch(updatedRoadSections(roadSections));
            dispatch(unsetReferenceModalToDisplay());
        } catch (err) {
            dispatch(setModalToDisplay(ReferenceModalTypes.ROAD_SECTION_EDIT_FAILURE));
        }
    },
);

export default editRoadSections;
